export type View = 'internal' | 'summary' | 'detail';
export interface Criteria {
  mode: 'billto' | 'customer'; recno: number; name: string; filter: number[]; years: number; view: View;
}
export const EMPTY_CRITERIA: Criteria = { mode: 'billto', recno: 0, name: '', filter: [], years: 2, view: 'internal' };
export const SECTION_NAMES = ['summary', 'orders', 'warehouse', 'quotes', 'invoicing', 'chassis', 'system', 'contacts'] as const;
export type Section = typeof SECTION_NAMES[number];
export function sectionsForView(view: View): Section[] {
  return SECTION_NAMES.filter(s => view === 'internal' || (view === 'summary' ? ['summary', 'orders', 'chassis'].includes(s) : !['system', 'contacts'].includes(s)));
}
export function parseCriteria(search: string): Criteria | null {
  const p = new URLSearchParams(search);
  const mode = p.get('mode') ?? 'billto', view = p.get('view') ?? 'internal';
  const recno = Number(p.get('recno')), years = Number(p.get('years') ?? 2), filter = p.get('filter') ?? '';
  if (!['billto', 'customer'].includes(mode) || !['internal', 'summary', 'detail'].includes(view) ||
      !Number.isSafeInteger(recno) || recno <= 0 || !Number.isInteger(years) || years < 2 || years > 5 ||
      (filter && (filter.length > 10000 || !/^[1-9]\d*(,[1-9]\d*)*$/.test(filter)))) return null;
  const ids = filter ? [...new Set(filter.split(',').map(Number))] : [];
  if (ids.some(id => !Number.isSafeInteger(id))) return null;
  return { mode: mode as Criteria['mode'], recno, years, view: view as View, filter: ids, name: p.get('name') ?? `#${recno}` };
}
export function serializeCriteria(c: Criteria): string {
  return new URLSearchParams({ mode: c.mode, recno: String(c.recno), name: c.name, filter: c.filter.join(','), years: String(c.years), view: c.view }).toString();
}
